export default __webpack_public_path__ + "static/ready_to_hire_banner-422bbc20854c917d4c68bbdc44674147.webp";